const STRoles = {
  Admin: 'admin',
  Editor: 'editor',
  Writer: 'writer',
  Customer: 'customer',
  developmentalEditor: 'developmentalEditor',
  contentTeam: 'contentTeam',
  proProofreader: 'proProofreader',
};

export default STRoles;
